import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import BackArrowHeader from "../../../../commons/arrow/BackArrowHeader";
import ExportButton from "../../../../commons/export/ExportButton";
import {
  tableStyles
} from "../../../../commons/table/tableConfig";
import TitleContainer from "../../../../commons/table/utilsTable/TitleWithFetchData";

const TrabajadoresTable = ({ data, loading, handleGoBack }) => {
  const columns = [
    {
      header: "Número de Documento",
      enableColumnActions: false,
      accessorKey: "numeroDocumento",
      render: (rowData) =>
        // que el numero de documento tenga formato de miles
        Intl.NumberFormat("es-AR").format(rowData.numeroDocumento),
    },
    {
      header: "Apellido, Nombre/s",
      enableColumnActions: false,
      accessorKey: "nombreCompleto",
    },
  ];

  return (
    <MaterialReactTable
      columns={columns}
      layoutMode="grid"
      state={{ isLoading: loading }}
      localization={MRT_Localization_ES}
      initialState={{ showColumnFilters: true }}
      data={data}
      style={{ ...tableStyles.container }}
      options={{
        headerStyle: tableStyles.headerStyle,
        rowStyle: tableStyles.rowStyle,
      }}

      renderToolbarInternalActions={() => (
        <ExportButton data={data} columns={columns} title="Trabajadores Expuestos" />
      )}
      renderTopToolbarCustomActions={() => (
        <div>
          <div style={{ paddingTop: 10 }}>
            <BackArrowHeader
              onClick={handleGoBack}
              title="Resumen de gestión"
            />
          </div>
          <div>
            <TitleContainer title="Trabajadores Expuestos" />
          </div>
        </div>
      )}
    />
  );
};

export default TrabajadoresTable;
